import Products_A from './Products_A'
import Products_B from './Products_B'
import Products_C from './Products_C'
import Products_D from './Products_D'
import Products_E from './Products_E'
import Products_F from './Products_F'
import Products_G from './Products_G'

const Products = {
  A: Products_A,
  B: Products_B,
  C: Products_C,
  D: Products_D,
  E: Products_E,
  F: Products_F,
  G: Products_G
}

export default Products



// WEBPACK FOOTER //
// ./src/components/Products.js